module.exports = __webpack_public_path__ + "static/media/icon-quality-lime.2f591d8e.svg";